<template>
<div>
  <router-view></router-view>
  <loader></loader>
</div>
</template>

<script>
import Loader from './components/Loader'

export default {
  name: 'App',
  components: {Loader}
}
</script>

<style>
.content {
  padding-left: 3px;
  padding-right: 3px;
}

.clients-contact {
  width: 14%;
}

.product-code {
  width: 5%;
}

.product-id {
  width: 5%;
}

#category .dropdown-toggle {
  min-width: 200px;
  /*height: 34px;*/
  cursor: pointer;
  border-radius: 0;
}

#category .selected-tag {
  /*width: 100%;*/
  height: 28px;
  font-size: 12px;
  overflow: hidden;
  /*text-overflow: clip;*/
  /*white-space: nowrap;*/
  margin: 2px;
}

/*#category .selected-tag .close {*/
  /*position: absolute;*/
  /*right: 10px;*/
/*}*/

#category input {
  margin: 0;
  font-size: 14px;
  /*line-height: 1.42857143;*/
  color: #555;
}

/*#category .close {*/
/*  cursor: pointer;*/
/*}*/

.table-bordered > thead > tr > th, .table-bordered > thead > tr > td {
    padding-left: 3px;
    padding-right: 3px;
}

.table-bordered > thead > tr > th input {
    padding: 6px 3px;
}

.VueTables__sort-icon {
    font-size: 12px;
}

.__vev_calendar-wrapper .cal-wrapper .cal-header {
  background: none;
}

body {
  font-size: 18px;
}

.sidebar-mini.sidebar-collapse .main-sidebar {
  display: none;
}

.sidebar-mini.sidebar-collapse .content-wrapper, .sidebar-mini.sidebar-collapse .right-side, .sidebar-mini.sidebar-collapse .main-footer {
  margin-left: 0 !important;
}

.sidebar-mini.sidebar-collapse .main-header .logo {
  display: none;
}

.sidebar-mini.sidebar-collapse .main-header .navbar {
  margin-left: 0;
}

@media print {
  .show-print {
    color: red;
    display: block !important;
  }

  a[href]:after {
    content: none !important;
  }
}

.sidebar-toggle, .sidebar-toggle:hover {
    position: absolute;
    color: #3c8dbc !important;
}

.content-header {
    padding-top: 0;
    margin: 0 0 0 25px;
}

.content-header h1 {
    margin: 0;
    font-size: 24px;
}

.VueTables__table thead tr:first-child {
    display: none;
}

.main-sidebar {
    padding-top: 50px;
}

.invalid-feedback {
    color: red;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    padding: 3px;
}

.table-hover > tbody > tr:hover {
    background-color: #fff7e2;
}

.vs__actions {
    display: none !important;
}

</style>